/**
 * Item-only datatable search/select helpers (mirrors dt-search) so we can pass
 * onSelectDone after every reload without modifying shared dt-search.js.
 */
const debounce = require('../../../../../js-handler/debounce');
const dtDbGeneral = require('../../../../../components/dt/dt-db-general');
const dtGenerator = require('../../../../../components/dt/dt-generator');
const dtSearchHandler = require('../../../../../components/dt/dt-search-handler');
const inf = require('../../../../../js-network/inf');

export function filter(detail, htmlDt, onSelectDone) {
	if (dtSearchHandler.filterSeachCancel(htmlDt)) {
		return;
	}
	debounce.start(() => {
		dtSearchHandler.cleanDt(htmlDt);
		select(detail, htmlDt, true, onSelectDone);
	});
}

export function filterShowHide(detail, htmlDt, onSelectDone) {
	if (dtSearchHandler.filterShowHide(htmlDt)) {
		return;
	}
	dtSearchHandler.cleanDt(htmlDt);
	select(detail, htmlDt, true, onSelectDone);
}

export function loadMore(detail, htmlDt, onSelectDone) {
	if (dtSearchHandler.isDisableFooter(detail)) {
		return;
	}
	dtSearchHandler.increaseFooter(htmlDt);
	select(detail, htmlDt, false, onSelectDone);
}

export function searching(detail, htmlDt, userCallback, onSelectDone) {
	detail.ev.target.classList.add('searching');

	if (dtSearchHandler.searchCancel(htmlDt)) {
		detail.ev.target.classList.remove('searching');
		return;
	}

	debounce.start(() => {
		dtSearchHandler.cleanDt(htmlDt);
		select(detail, htmlDt, true, (result, availableRowsWithFilters, resultComplete) => {
			detail.ev.target.classList.remove('searching');
			if (userCallback != undefined) {
				userCallback(resultComplete);
			}
			if (onSelectDone != undefined) {
				onSelectDone(result, availableRowsWithFilters, resultComplete);
			}
		});
	});
}

export function th(detail, htmlDt, onSelectDone) {
	dtSearchHandler.cleanDt(htmlDt);
	select(detail, htmlDt, false, onSelectDone);
}

export function select(detail, htmlDt, cleanTable, callback) {
	inf.toSelect(detail, htmlDt);

	dtDbGeneral.select(detail, htmlDt, (result, availableRowsWithFilters, resultComplete) => {
		const dataOrganized = htmlDt.organizeRow(result);
		dtGenerator.addBody(dataOrganized, htmlDt, cleanTable);

		dtSearchHandler.updateFooter(htmlDt, availableRowsWithFilters);

		if (callback != undefined) {
			callback(result, availableRowsWithFilters, resultComplete);
		}
	});
}
